import {ServiceEventType, serviceEventTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";
import {Button, Modal, ModalProps, Stack} from "@mantine/core";
import {useCallback, useState} from "react";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

type Props = DbCodeSelectProps<ServiceEventType>;

export const ServiceEventTypeSelect = (props: Props) => {
  const {options = serviceEventTypes, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};

export interface ServiceEventTypeSelectModalProps extends Omit<ModalProps, "onSubmit"> {
  select?: Omit<Props, 'label' | 'placeholder' | 'withinPortal' | 'clearable' | 'onEntityChange'>,
  onSubmit?: (sites: ServiceEventType[] | undefined) => void
}

export const ServiceEventTypeSelectModal = (props: ServiceEventTypeSelectModalProps) => {
  const {
    select,
    onSubmit,
    ...rest
  } = props;

  const [selectedServiceEventTypes, setSelectedServiceEventTypes] = useState<ServiceEventType[]>([])

  const {t} = useTranslation(["common"]);

  const form = useForm({
    initialValues: {
      abacPolicy: undefined,
    },
    validate: {}
  });

  const onFormSubmit = useCallback(async (values: typeof form.values) => {
    if (onSubmit) {
      // noop
    }
  }, [form, onSubmit]);

  return (
    <Modal {...rest}>
      <form onSubmit={form.onSubmit(onFormSubmit)}>
        <Stack spacing="md">
          <ServiceEventTypeSelect
            {...select}
            label={t("common.entity.serviceeventtype", "Service Event Type")}
            placeholder={t("common.entity.serviceeventtype", "Service Event Type")}
            withinPortal={true}
            clearable
            onDbCodeChange={e => setSelectedServiceEventTypes(e)}
            {...form.getInputProps("abacPolicy")} />
          <Button type="submit" mt="xl" onClick={(e) => {
            if (onSubmit) {
              onSubmit(selectedServiceEventTypes);
            }
          }}>
            {t("common.action.submit")}
          </Button>
        </Stack>
      </form>
    </Modal>
  );
};
